import { FC } from 'react';
import { Flex, Text, BoxProps } from '@chakra-ui/react';
import { ICON_BY_NAME } from 'ui/components/Icons/Icon';
import { CbTableSelectorPopover } from '../CbTableSelectorPopover';
export interface CbTableDropdownFilterProps extends BoxProps {
  dropdownFilters?: string[];
  filter?: string;
  width?: string;
  handleChange?: (newValue: any) => void;
}
export const CbTableDropdownFilter: FC<CbTableDropdownFilterProps> = ({
  dropdownFilters,
  filter,
  width,
  handleChange,
  ...props
}) => {
  if (!dropdownFilters) {
    return null;
  }
  return <CbTableSelectorPopover options={dropdownFilters} trigger={<Flex justifyContent="space-between" alignItems="center" as="button" disabled={dropdownFilters.length === 0} height={10} paddingX={4} width={width || ''} borderRadius={50} borderColor="cloud.300" color="text.primary" borderWidth="1.5px" backgroundColor="transparent" marginTop={{
    base: 4,
    md: 0
  }} _hover={{
    borderColor: 'cloud.400'
  }} {...props}>
          <Text marginRight={4}>{filter}</Text>
          <ICON_BY_NAME.chevrondown height={3} width={3} />
        </Flex>} onChange={handleChange} data-sentry-element="CbTableSelectorPopover" data-sentry-component="CbTableDropdownFilter" data-sentry-source-file="CbTableDropdownFilter.tsx" />;
};